import { isProductionUrl, isQa } from '@/environment-detection'
import {
  PAYMENT_PERIOD_TO_SHOW_POPUP,
  DAYS_BETWEEN_SHOWING_PAYMENT_POPUP
} from '@/modules/layout/constants'

import {
  CAN_USE_PAYMENT_DIALOG,
  CAN_USE_ORCAS_TMS_PORTAL
} from '@/components/user-permissions'

const MA_FEATURE_TESTER = 'OrcasMATester'

export const truckTypes = state => {
  // eslint-disable-next-line
  const { BUS, CAR, ...rest } = state.vehicleTypes
  return rest
}

export const contactInfo = state => {
  if (!state.partnerManager) return null
  const { firstName, lastName } = state.partnerManager
  return { ...state.partnerManager, fullName: firstName + ' ' + lastName }
}

export const isFirstLogin = state => state.currentUser.firstLogin

export const teamMembers = state => state.teamMembers

export const openAssignmentsCount = state => state.openAssignmentsCount

export const canUseCarrierTimesFeature = state => {
  if (!isProductionUrl() && !isQa()) return true
  return state.currentUserGroups.includes('Engineer')
}
export const currentUser = state => state.currentUser

export const currentCarrierCompany = state => state.currentCarrierCompany

export const canUseMAFeature = state =>
  state.currentUserGroups.includes(MA_FEATURE_TESTER)

export const hasPermissionToSeePaymentDialog = state =>
  state.currentUser && state.currentUser.permissions.includes(CAN_USE_PAYMENT_DIALOG)

export const hasProperPaymentDaysToSeeDialog = state =>
  state.currentCarrierCompany &&
  state.currentCarrierCompany.carrierPaymentDays === PAYMENT_PERIOD_TO_SHOW_POPUP

export const hasPermissionAndProperInvoicingTerms = (state, getters) =>
  getters.hasProperPaymentDaysToSeeDialog && getters.hasPermissionToSeePaymentDialog

export const canSeeDialogUponLoggingIn = state => {
  const { currentUser } = state
  const lastShownDateFormat = currentUser.paymentTermPopUpDaysPast

  return (
    lastShownDateFormat === null ||
    lastShownDateFormat >= DAYS_BETWEEN_SHOWING_PAYMENT_POPUP
  )
}

export const userHasAcceptedEssentialCookies = state =>
  state.currentUser && state.currentUser.cookies.includes('ESSENTIAL')

export const userHasAcceptedAnalyticsCookies = state =>
  state.currentUser && state.currentUser.cookies.includes('ANALYTICS')

export const defaultUserLanguage = state => state.currentUser.uiLanguage

export const vehicleTypes = state => state.vehicleTypes

export const isBannerOpen = state => state.isBannerOpen

export const canUseOrcasTmsPortal = state =>
  state.currentUser && state.currentUser.permissions.includes(CAN_USE_ORCAS_TMS_PORTAL)
